import { ALEX_STATES, GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = { alexState: ALEX_STATES.INACTIVE };

const alexReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_ALEX_INACTIVE:
      return { ...state, alexState: ALEX_STATES.INACTIVE };
    case REDUX_ACTIONS.SET_ALEX_ACTIVE:
      return { ...state, alexState: ALEX_STATES.ACTIVE };
    case REDUX_ACTIONS.SET_ALEX_SPEAKING:
      return { ...state, alexState: ALEX_STATES.SPEAKING };
    default:
      return state;
  }
};

export default alexReducer;
